import setup from './moduleSetup';

export default {
    name: 'interOffice',
    before: [],
    after: [],
    setup,
};
